<template>
	<div>
		<b-row class="mt-3">
			<b-col>
				<b-link class="float-right ml-3" @click.prevent="deleteRoute" title="Delete this route">
					<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
				</b-link>
			</b-col>
		</b-row>

		<b-row>
			<b-col cols="5">
				<b-form-group :label-cols="2" horizontal label="Technician:" for="engineer">
					<b-col :md="8">
						<b-form-select @change="engineerChosen" id="engineer" v-model="selectedEngineer" value-field="Id" text-field="FullName" :options="engineers"></b-form-select>
					</b-col>
				</b-form-group>

				<b-card v-if="selectedEngineer" no-body>
					<b-tabs card v-model="selectedDay">
						<b-tab v-for="(day, key) in route.days" :key="key">
							<template v-slot:title>
								<div @dragenter="tabDragOver(key)">Day {{ key + 1 }}</div>
							</template>


							<b-link v-if="key > 0" class="float-left  mb-2" @click.prevent="removeFromArray('days', key, true)" title="Delete this day">
								<b-icon icon="trash" variant="danger"></b-icon>
							</b-link>


							<b-input-group prepend="Start date and time" class="mb-2">
								<b-form-datepicker v-model="day.startDate" required @input="setDayDate" @context="recalcTimes"></b-form-datepicker>

								<b-form-timepicker v-model="day.startTime" locale="en" @input="setDayDate" @context="recalcTimes"></b-form-timepicker>
							</b-input-group>

							<b-row>
								<b-col cols="6">
									<b-alert show variant="light">
										Distance
										<b-badge>{{ dayDistance }}</b-badge>
									</b-alert>
								</b-col>

								<b-col cols="6">
									<b-alert show variant="light">
										Time
										<b-badge>{{ dayTime }}</b-badge>
									</b-alert>
								</b-col>
							</b-row>

							<b-list-group>

								<draggable v-model="day.waypoints" @end="recalcWaypoints" group="assignments" @start="sorting = true" handle=".handle">

									<b-list-group-item v-for="(item, index) in day.waypoints" v-bind:key="index" class=" d-flex  flex-row  align-items-start  align-items-stretch" :variant="item.active ? 'primary' : 'light'" @mouseenter="wayPointMouseOver(index)" @mouseleave="wayPointMouseOut(index)">


										<div class="align-middle  pr-2">
											<b-link title="Change order">
												<b-icon class="handle" font-scale="1.5" icon="list"></b-icon>
											</b-link>
										</div>

										<div class="flex-grow-1">

											<div class="d-flex w-100 justify-content-between">


												<h6 class="mb-1">
													<strong>{{ index + 1 }}.</strong>

													<b-badge variant="info">{{ niceTime(item.start) }}<span v-if="item.end != item.start"> - {{ niceTime(item.end) }}</span></b-badge>

													<strong>
														{{ item.name }}
													</strong>

													<span v-html="item.description"></span>
												</h6>

												<span>
													<b-form-checkbox v-if="item.type == 4" class="ml-3 float-left" v-model="item.confirmed" switch value="true" unchecked-value="false">Confirmed?</b-form-checkbox>

													<b-link class="ml-3 float-right" v-if="index > 0 && !item.Editable" title="Remove waypoint" @click.prevent="removeWaypoint(index)">
														<b-icon font-scale="1.5" icon="dash-square" variant="danger"></b-icon>
													</b-link>

													<save-or-edit-buttons-row v-if="index > 0" :section="item" @save="updateWaypoint(item)"></save-or-edit-buttons-row>
												</span>

											</div>
											

											<div class="d-flex w-100 flex-column">
												<small class="p-1">{{ item.address.Address1 }},{{ item.address.Address2 }},{{ item.address.Town }},{{ item.address.County }}, {{ item.address.Postcode }} {{ item.address.What3Words }}</small>

												<small class="p-1"><span v-if="item.distance > 0">
														Driving distance:
														<b-badge variant="info">{{ item.distanceText }}</b-badge>
														Driving time:
														<b-badge variant="info">{{ item.timeText }}</b-badge></span>
												</small>

												<span class="p-1" v-if="item.Editable">
													<b-form inline><small>Stop-over time: </small>
														<b-col cols="3">
															<b-input-group prepend="Hours" size="sm">
																<b-input v-model="item.layOver.hours" type="number" size="sm" min="0" step="1" />
															</b-input-group>
														</b-col>

														<b-col cols="3">
															<b-input-group prepend="Minutes" size="sm">
																<b-input v-model="item.layOver.mins" type="number" size="sm" min="0" step="1" />
															</b-input-group>
														</b-col>

														<b-col cols="3" v-if="item.type == 3">
															<b-input-group prepend="Reference" size="sm">
																<b-input v-model="item.description" type="text" size="sm" />
															</b-input-group>
														</b-col>


													</b-form>
												</span>

												<span v-else class="p-1">
													<small v-if="item.layOver.seconds > 0">Stop-over time: <b-badge variant="info">{{ item.layOver.text }}</b-badge></small>
												</span>
											</div>

										</div>
										
									</b-list-group-item>
								</draggable>
							</b-list-group>
						</b-tab>

						<template #tabs-end>
							<b-nav-item role="presentation" @click.prevent="addDay" href="#" title="Add a new day">
								<b>+</b>
							</b-nav-item>
						</template>
					</b-tabs>
				</b-card>

				<b-row class="mt-3">
					<b-col>
						<b-button variant="outline-primary" @click.prevent="saveRoute">Save Route</b-button>
					</b-col></b-row>
			</b-col>

			<b-col cols="7">
				<b-row>
					<b-col>
						<div class="d-inline-block" v-for="layer in layers" :key="layer.id">
							<b-form-checkbox class="mr-5 mb-3" v-model="layer.active" :value="true" @input="layerChanged(layer.id, layer.active)" switch> Show {{ layer.name }} </b-form-checkbox>
						</div>
					</b-col>
				</b-row>

				<div id="map" class="map"></div>
			</b-col>

			<b-modal title="Add waypoint?" centered ref="waypointRef" @ok="confirmWaypoint">
				<b-form-fieldset>
					<h3>{{ tempWaypoint.name }}</h3>

					<legend>Add stop-over time?</legend>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Hours:" for="layover-hours">
						<b-col :md="5">
							<b-input id="layover-hours" v-model="tempWaypoint.layOver.hours" type="number" min="0" max="24" step="1" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Minutes:" for="layover-mins">
						<b-col :md="5">
							<b-input id="layover-mins" v-model="tempWaypoint.layOver.mins" type="number" min="0" max="59" step="1" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal v-if="tempWaypoint.canSave">
						<b-form-checkbox :value="true" v-model="tempWaypoint.save">Permanently save stop?</b-form-checkbox>
					</b-form-group>
				</b-form-fieldset>
			</b-modal>
		</b-row>

		<confirm ref="confirm"></confirm>
	</div>
</template>

<script>
import ClockService from '@/api-services/clock.service';
import AssignmentService from '@/api-services/assignment.service';
import AccountService from '@/api-services/account.service';
import RestStopService from '@/api-services/reststop.service.js';
import GmapsInit from '@/api-services/gmaps.init';
import Draggable from 'vuedraggable';
import Confirm from '@/components/partials/confirm';
import SaveOrEditButtonsRow from '@/components/partials/save-or-edit-buttons-row';

import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

import 'leaflet-control-geocoder';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';

import ExtraMarkers from 'leaflet-extra-markers';
import 'leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css';

import Markercluster from 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

// import shares functions
import { dateFuncs } from '@/globs.js';

// import shared variables
var startMarker = null;
var routeLines = [];

const waypointType = {
	start: 0,
	technician: 1,
	clock: 2,
	stop: 3,
	job: 4
};

function createWaypoint() {
	return {
		markerId: null,
		active: false,
		type: null,
		name: '',
		description: '',
		distanceText: '',
		timeText: '',
		address: {},
		distance: 0,
		time: 0,
		layOver: {
			text: '',
			hours: 0,
			mins: 0,
			seconds: 0
		},
		start: null,
		end: null,
		canSave: false,
		save: false,
		confirmed: false,
		scheduled: null,
		sourceId: null
	};
}

function createRoute() {
	return {
		days: [
			{
				startDate: dateFuncs.today(),
				startTime: '09:00',
				waypoints: [],
				locked: false,
				recalc: false,
				totals: {
					distance: 0,
					time: 0
				}
			}
		],
		totals: {
			distance: 0,
			time: 0
		}
	};
}

export default {
	name: 'RoutePlanInner',

	props: ['updating'],

	components: {
		Draggable,
		Confirm,
		SaveOrEditButtonsRow
	},

	computed: {
		dayDistance: function () {
			return this.getMiles(this.route.days[this.selectedDay].totals.distance);
		},
		dayTime: function () {
			return this.getHoursMins(this.route.days[this.selectedDay].totals.time);
		},

		totalDistance: function () {
			return this.getMiles(this.route.totals.distance);
		},
		totalTime: function () {
			return this.getHoursMins(this.route.totals.time);
		}
	},

	data() {
		return {
			routeId: null,
			clocks: [],
			jobs: [],
			engineers: [],
			stops: [],

			selectedEngineer: null,

			tempWaypoint: createWaypoint(),

			route: createRoute(),

			selectedDay: 0,

			searchMarker: null,

			map: null,
			tileLayer: null,
			layers: [
				{
					id: 0,
					name: 'Clocks',
					active: true,
					features: []
				},
				{
					id: 1,
					name: 'Stops',
					active: true,
					features: []
				},
				{
					id: 3,
					name: 'Jobs',
					active: true,
					features: []
				}
			],

			gMan: null,

			sorting: false
		};
	},

	mounted() {
		// initialize the map after DOM has loaded
		this.initMap();

		// start gmaps up so we can use distance.
		const google = GmapsInit();
	},

	created() {
		// route is dependant on engineers being populated.

		this.fetchEngineers().then(() => {
			this.fetchClocks();

			this.fetchStops();

			// finally get the saved route from the api
			if (this.updating) {
				this.fetchRoute();
			}
		});
	},

	methods: {
		fetchRoute() {
			this.$parent.routePlanService
				.get(this.$router.currentRoute.params.id)
				.then((res) => {

					let routeDTO = res.data;

					this.routeId = routeDTO.Id;

					this.selectedEngineer = routeDTO.ApplicationUserId;

					this.engineerChosen(routeDTO.ApplicationUserId);

					routeDTO.Data.days.forEach((day) => {
						day.startDate = dateFuncs.frontEndDateFormat(day.startDate);
					});

					this.route = routeDTO.Data;

					this.drawLines();
				})
				.catch((error) => {
					this.handleError(error);
				});
		},

		tabDragOver(tabIndex) {
			// selectedDay is current tab index
			this.selectedDay = tabIndex;
		},

		wayPointMouseOver(index, fromMap = false) {
			let day = this.selectedDay;

			if (fromMap) {
				// if we have come from the map, then we need to get the index of the list item by it's marker id.
				index = this.route.days[day].waypoints.findIndex((obj) => obj.markerId == index);
			}

			//now pick up the object by that index
			let waypoint = this.route.days[day].waypoints[index];

			if (typeof waypoint != 'undefined') {
				let markerId = waypoint.markerId;

				waypoint.active = true;

				if (!fromMap) {
					if (typeof this.map._layers[markerId] != 'undefined') {
						this.map._layers[markerId].openPopup();
					}
				}
			}
		},

		wayPointMouseOut(index, fromMap = false) {
			let day = this.selectedDay;

			if (fromMap) {
				index = this.route.days[day].waypoints.findIndex((obj) => obj.markerId == index);
			}

			let waypoint = this.route.days[day].waypoints[index];

			if (typeof waypoint != 'undefined') {
				let markerId = waypoint.markerId;
				waypoint.active = false;

				if (!fromMap) {
					if (typeof this.map._layers[markerId] != 'undefined') {
						this.map._layers[markerId].closePopup();
					}
				}
			}
		},

		saveRoute() {
			let routeDTO = {
				ApplicationUserId: this.selectedEngineer,
				Data: this.route,
				Assignments: []
			};

			if (this.updating) {
				routeDTO.Id = this.routeId;
			}

			this.$emit('update', routeDTO);
		},

		deleteRoute() {
			this.$refs.confirm.open('Delete', 'Are you sure you want to delete this route?').then((confirm) => {
				if (confirm) {
					this.$parent.routePlanService
						.delete(this.routeId)
						.then(() => {
							this.$refs.confirm.open('Success', 'Successfully deleted route', true).then((confirm) => {
								this.$router.push({ name: 'routeplans' });
							});
						})
						.catch((error) => {
							this.handleError(error);
						});
				}
			});
		},

		addDay() {
			let testRowIndex =
				this.route.days.push({
					waypoints: [],
					locked: false,
					totals: {
						distance: 0,
						time: 0
					}
				}) - 1;

			this.route.days[testRowIndex].startDate = dateFuncs.daysAfterTomorrow(testRowIndex);
			this.route.days[testRowIndex].startTime = '09:00';

			// push the last waypoint from the last day into the first slot of the new day, makes sense right?!
			if (this.selectedDay >= 0) {
				let previousDayRoute = this.route.days[this.selectedDay].waypoints;

				let lastWayPoint = previousDayRoute.slice(-1)[0];

				let firstWayPoint = createWaypoint();
				firstWayPoint.markerId = lastWayPoint.markerId;
				firstWayPoint.name = lastWayPoint.name;
				firstWayPoint.address = lastWayPoint.address;
				firstWayPoint.type = waypointType.start;
				firstWayPoint.sourceId = lastWayPoint.sourceId;

				firstWayPoint.start = this.route.days[testRowIndex].startTime;
				firstWayPoint.end = firstWayPoint.start;

				this.route.days[testRowIndex].waypoints.push(firstWayPoint);

				this.map.setView([lastWayPoint.address.Latitude, lastWayPoint.address.Longitude], 9);

				// the new tab won't have rendered straight away.
				setTimeout(() => {
					this.selectedDay = testRowIndex;
				}, 250);
			}
		},

		// if we change the last thing on a day, the first thing the next day needs to change
		resetDay(_day) {
			let previousDayRoute = this.route.days[this.selectedDay].waypoints;
			let nextDayRoute = this.route.days[_day].waypoints;

			let firstWayPoint = nextDayRoute[0];

			let lastWayPoint = previousDayRoute.slice(-1)[0];

			firstWayPoint.markerId = lastWayPoint.markerId;
			firstWayPoint.name = lastWayPoint.name;
			firstWayPoint.address = lastWayPoint.address;
			firstWayPoint.type = waypointType.start;
			firstWayPoint.sourceId = lastWayPoint.sourceId;

			this.route.days[_day].recalc = true;
		},

		removeFromArray(section, index, hold) {
			if (hold) {
				this.$refs.confirm.open('Confirm action', 'Are you sure you want to remove this item from ' + section).then((confirm) => {
					if (confirm) {
						this.removeFromArray(section, index);
					}
				});

			} else {

				this.selectedDay = index - 1;
				this.$delete(this.route[section], index);

				//this.updateContact();
			}
		},

		fetchClocks() {
			ClockService.getAll().then((response) => {
				this.clocks = response.data;

				this.clocks.map((clock) => {
					if (clock.Address.Latitude == null && clock.Address.Longitude == null) {
						// so we can set the map properly
						clock.Address.Empty = true;
					}

					return clock;
				});

				// add clock markers to map
				this.initLayer(0, true);
			});
		},

		fetchJobs(query) {
			if (this.updating) {
				// this.routeId
				query = query + '&routeId=' + this.routeId;
			}

			AssignmentService.search(query).then((response) => {
				//AssignmentService.getAll().then((response) => {
				this.jobs = response.data;

				this.jobs.map((job) => {
					if (job.Address.Latitude == null && job.Address.Longitude == null) {
						// so we can set the map properly
						job.Address.Empty = true;
					}

					return job;
				});

				// add clock markers to map
				this.initLayer(3, true);
			});
		},

		fetchStops() {
			RestStopService.getAll().then((response) => {
				this.stops = response.data;

				this.stops.map((stop) => {
					if (stop.Address.Latitude == null && stop.Address.Longitude == null) {
						// so we can set the map properly
						stop.Address.Empty = true;
					}

					return stop;
				});

				// add  markers to map
				this.initLayer(1, true);
			});
		},

		fetchEngineers() {
			return AccountService.getAll().then((response) => {
				this.engineers = response.data;

				this.engineers.map((engineer) => {
					if (!engineer.Address) {
						engineer.Address = {
							Empty: true
						};
					} else if (engineer.Address.Latitude == null && engineer.Address.Longitude == null) {
						// so we can set the map properly
						engineer.Address.Empty = true;
					}

					return engineer;
				});
			});
		},

		async fetchDistance(origin, dest) {
			return new Promise((resolve, reject) => {
				let response;
				if (this.gMan == null) this.gMan = new google.maps.DistanceMatrixService();

				let service = this.gMan;

				service.getDistanceMatrix(
					{
						origins: [origin],
						destinations: [dest],
						travelMode: 'DRIVING',
						unitSystem: google.maps.UnitSystem.IMPERIAL,
						avoidHighways: false,
						avoidTolls: true
					},
					function (resp, status) {
						if (status !== google.maps.DistanceMatrixStatus.OK) {
							response = reject(status);
						} else {
							response = resolve(resp);
						}
					}
				);
				return response;
			});
		},

		engineerChosen(Id) {
			// Engineer chosen, set start marker.
			var engineer = this.engineers.find((c) => c.Id == Id);

			var techMarker = new L.ExtraMarkers.icon({
				markerColor: 'green-light',
				shape: 'circle'
			});

			var vm = this;
			var marker = L.marker([engineer.Address.Latitude, engineer.Address.Longitude], { icon: techMarker });

			// use our own marker id so it never freakin' changes man.
			marker._leaflet_id = Id;

			marker._properties = {
				id: 0,
				type: waypointType.technician,
				name: engineer.FullName,
				title: '',
				address: engineer.Address,
				date: '',
				confirmed: null
			};

			marker.bindPopup(engineer.FullName).on('click', function (e) {
				vm.addWaypoint(this._leaflet_id, marker._properties, false);
			});

			marker.on('mouseover', function (e) {
				this.openPopup();
				vm.wayPointMouseOver(this._leaflet_id, true);
			});
			marker.on('mouseout', function (e) {
				this.closePopup();
				vm.wayPointMouseOut(this._leaflet_id, true);
			});

			// clear existing engineer marker
			this.removeStartMarker();

			// since we are adding a new technician we should just start again with waypoints
			// we should get the job layer again, because they are now specific to the engineer.

			Object.assign(this.route, createRoute());

			this.fetchJobs(Id);

			// add new start marker
			startMarker = marker.addTo(this.map);

			// re-centre on engineer marker
			this.map.setView([engineer.Address.Latitude, engineer.Address.Longitude], 9);

			// add start point
			vm.addWaypoint(marker._leaflet_id, marker._properties, false);
		},

		removeStartMarker() {
			if (startMarker != null) {
				this.map.removeLayer(startMarker);
			}
		},

		canAddWaypoint(markerId) {
			let ok = true;
			this.route.days.forEach((day) => {
				if (day.waypoints) {
					day.waypoints.forEach((waypoint) => {
						if (waypoint.markerId == markerId && waypoint.type == 4) {
							ok = false;
							return;
						}
					});
				}
			});
			return ok;
		},

		addWaypoint(markerId, marker_properties, canSave) {
			// we do not want to add waypoints if there is no engineer selected, or it is a job that we already have in our route

			if (this.selectedEngineer && this.canAddWaypoint(markerId)) {
				// get a new waypoint ready.
				let day = this.selectedDay;

				this.tempWaypoint.markerId = markerId;
				this.tempWaypoint.type = marker_properties.type;
				this.tempWaypoint.name = marker_properties.name;
				this.tempWaypoint.description = marker_properties.title;
				this.tempWaypoint.address = marker_properties.address;
				this.tempWaypoint.scheduled = this.route.days[day].startDate;
				this.tempWaypoint.confirmed = marker_properties.confirmed;
				this.tempWaypoint.sourceId = marker_properties.id;
				this.tempWaypoint.canSave = canSave;

				if (this.route.days[day].waypoints.length > 0) {
					// stop now and take layover input
					this.$refs.waypointRef.show();
				} else {
					this.confirmWaypoint();
				}
			}
		},

		updateWaypoint(waypoint) {
			// have they edited this?
			console.log(waypoint);

			// confirmed should move parent job to booked status.
			if (waypoint.Confirmed) { }

			let layOverMins = waypoint.layOver.mins;
			let layOverHours = waypoint.layOver.hours;
			let layOverSeconds = layOverHours * 60 * 60 + layOverMins * 60;

			waypoint.layOver.seconds = layOverSeconds;
			waypoint.layOver.text = this.getHoursMins(layOverSeconds);

			this.recalcTimes();
		},

		setDayDate(e) {
			this.$refs.confirm.open('Warning', 'This will change the order of the other days, ok?', true).then((confirm) => {
				this.recalcTimes();

				this.route.days.sort((a, b) => {
					return new Date(a.startDate) - new Date(b.startDate);
				});

				var index = this.route.days
					.map(function (obj) {
						return obj.startDate;
					})
					.indexOf(e);

				this.selectedDay = index;
			});
		},

		drawLines() {
			if (routeLines.length > 0) {
				for (var i = 0; i < routeLines.length; i++) {
					this.map.removeLayer(routeLines[i]);
				}
				routeLines = [];
			}

			let day = this.selectedDay;
			let lineColour = day % 2 == 0 ? 'red' : 'blue';

			this.route.days[day].waypoints.forEach((thisWaypoint, i) => {
				if (i > 0) {
					let prevWaypoint = this.route.days[day].waypoints[i - 1];

					let origin = L.latLng(prevWaypoint.address.Latitude, prevWaypoint.address.Longitude);

					let dest = L.latLng(thisWaypoint.address.Latitude, thisWaypoint.address.Longitude);

					let mapLine = L.polyline([origin, dest], {
						color: lineColour
					})
						.bindTooltip('' + i)
						.addTo(this.map);

					routeLines.push(mapLine);
				}
			});
		},

		async confirmWaypoint() {
			if (this.selectedEngineer) {
				// get the POCO out of the vue object, we don't want all that stuff in our array.
				let tempWaypoint = Object.assign({}, this.tempWaypoint);

				// layover part
				let layOverMins = tempWaypoint.layOver.mins;
				let layOverHours = tempWaypoint.layOver.hours;
				let layOverSeconds = layOverHours * 60 * 60 + layOverMins * 60;

				tempWaypoint.layOver.seconds = layOverSeconds;
				tempWaypoint.layOver.text = this.getHoursMins(layOverSeconds);

				let day = this.selectedDay;

				if (this.route.days[day].waypoints.length > 0) {
					var prevWaypoint = this.route.days[day].waypoints.slice(-1)[0];
					var origin = L.latLng(prevWaypoint.address.Latitude, prevWaypoint.address.Longitude);
					var dest = L.latLng(tempWaypoint.address.Latitude, tempWaypoint.address.Longitude);

					// google maps distance matrix, wait for deferred response
					var response = await this.fetchDistance(origin, dest);
					var gMatrix = response.rows[0].elements[0];

					// day totals
					this.route.days[day].totals.distance += gMatrix.distance.value;
					this.route.days[day].totals.time += gMatrix.duration.value;

					// grand totals
					this.route.totals.distance += gMatrix.distance.value;
					this.route.totals.time += gMatrix.duration.value;

					// work out start time of the stop
					let startDateTime = dateFuncs.getValidDate(this.route.days[day].startDate + ' ' + prevWaypoint.end);

					tempWaypoint.start = dateFuncs.addTime(startDateTime, gMatrix.duration.value);
					tempWaypoint.end = tempWaypoint.start;

					// add layover time
					if (layOverSeconds > 0) {
						this.route.days[day].totals.time += layOverSeconds;
						this.route.totals.time += layOverSeconds;

						// add layover time + travel time to the stop to get the approx end time.
						tempWaypoint.end = dateFuncs.addTime(startDateTime, gMatrix.duration.value + layOverSeconds);
					}

					if (tempWaypoint.save) {
						// let us save
						let stop = this.stops.find((stop) => stop.MapId === tempWaypoint.markerId);
						if (typeof stop == 'undefined') {
							let restStop = {
								Name: tempWaypoint.name,
								MapId: tempWaypoint.markerId,
								Address: tempWaypoint.address
							};
							RestStopService.create(restStop);
						}
					}

					if (tempWaypoint.end == null) {
						alert('Route time has gone past midnight and should make a new day...');
						this.route.days[day].locked = true;
					} else {
						this.route.days[day].locked = false;
					}

					tempWaypoint.distance = gMatrix.distance.value;
					tempWaypoint.time = gMatrix.duration.value;
					tempWaypoint.distanceText = gMatrix.distance.text;
					tempWaypoint.timeText = gMatrix.duration.text;

					this.route.days[day].waypoints.push(tempWaypoint);
				} else {
					// start point, take the overall day start time.

					tempWaypoint.start = dateFuncs.getTime(this.route.days[day].startDate + ' ' + this.route.days[day].startTime);
					tempWaypoint.end = tempWaypoint.start;

					this.route.days[day].waypoints.push(tempWaypoint);
				}

				// add poly lines for journey
				this.drawLines();

				Object.assign(this.tempWaypoint, createWaypoint());
			}
		},

		recalcTimes() {
			// assignments need the new date too.

			let day = this.selectedDay;
			let startDateTime;

			// zero day totals

			this.route.days[day].totals.time = 0;

			// and grand totals

			this.route.totals.time = 0;

			this.route.days[day].waypoints.forEach(async (thisWaypoint, i) => {
				if (i !== 0) {
					var prevWaypoint = this.route.days[day].waypoints[i - 1];

					// day totals
					this.route.days[day].totals.time += thisWaypoint.time;

					// work out start time of the stop
					startDateTime = dateFuncs.getValidDate(this.route.days[day].startDate + ' ' + prevWaypoint.end);

					thisWaypoint.start = dateFuncs.addTime(startDateTime, thisWaypoint.time);
					thisWaypoint.end = thisWaypoint.start;

					thisWaypoint.Scheduled = this.route.days[day].startDate; ////////////////

					// grand totals
					this.route.totals.time += thisWaypoint.time;
				} else {
					// this is the new journey start point, zero things, NOT LAYOVER

					thisWaypoint.time = 0;

					thisWaypoint.timeText = '';

					// reset start time
					startDateTime = dateFuncs.getValidDate(this.route.days[day].startDate + ' ' + this.route.days[day].startTime);
					thisWaypoint.start = this.route.days[day].startTime;
					thisWaypoint.end = thisWaypoint.start;
				}

				// add to total if layover time exists
				if (thisWaypoint.layOver.seconds > 0) {
					this.route.days[day].totals.time += thisWaypoint.layOver.seconds;
					this.route.totals.time += thisWaypoint.layOver.seconds;

					// add layover time + travel time to the stop to get the approx end time.
					thisWaypoint.end = dateFuncs.addTime(startDateTime, thisWaypoint.layOver.seconds + thisWaypoint.time);

					if (thisWaypoint.end == null) {
						alert('Route time has gone past midnight and should make a new day');
						this.route.days[day].locked = true;
					} else {
						this.route.days[day].locked = false;
					}
				}
			});
		},

		recalcWaypoints() {
			let day = this.selectedDay;

			let startDateTime;

			let hasMultipleDays = this.route.days.length == 1 ? false : true;
			let isLastDay = this.route.days.length == day + 1 ? true : false;
			let totalWaypoints = this.route.days[day].waypoints.length;

			// zero day totals
			this.route.days[day].totals.distance = 0;
			this.route.days[day].totals.time = 0;

			// and grand totals
			this.route.totals.distance = 0;
			this.route.totals.time = 0;

			this.route.days[day].waypoints.forEach(async (thisWaypoint, i) => {
				if (i !== 0) {
					var prevWaypoint = this.route.days[day].waypoints[i - 1];

					let origin = L.latLng(prevWaypoint.address.Latitude, prevWaypoint.address.Longitude);

					let dest = L.latLng(thisWaypoint.address.Latitude, thisWaypoint.address.Longitude);

					// calculate new route data
					let response = await this.fetchDistance(origin, dest);
					let gMatrix = response.rows[0].elements[0];

					thisWaypoint.distance = gMatrix.distance.value;
					thisWaypoint.time = gMatrix.duration.value;
					thisWaypoint.distanceText = gMatrix.distance.text;
					thisWaypoint.timeText = gMatrix.duration.text;

					// day totals
					this.route.days[day].totals.distance += thisWaypoint.distance;
					this.route.days[day].totals.time += thisWaypoint.time;

					// work out start time of the stop
					startDateTime = dateFuncs.getValidDate(this.route.days[day].startDate + ' ' + prevWaypoint.end);
					thisWaypoint.start = dateFuncs.addTime(startDateTime, thisWaypoint.time);
					thisWaypoint.end = thisWaypoint.start;

					thisWaypoint.Scheduled = this.route.days[day].startDate; ////////////////

					// grand totals
					this.route.totals.distance += thisWaypoint.distance;
					this.route.totals.time += thisWaypoint.time;

					// is this the last thing in a day? is there more than one day?
					if (totalWaypoints == i + 1 && hasMultipleDays && !isLastDay) {
						this.resetDay(day + 1);
					}
				} else {
					// this is the new journey start point, zero things, NOT LAYOVER
					thisWaypoint.distance = 0;
					thisWaypoint.time = 0;
					thisWaypoint.distanceText = '';
					thisWaypoint.timeText = '';

					// reset start time
					startDateTime = dateFuncs.getValidDate(this.route.days[day].startDate + ' ' + this.route.days[day].startTime);
					thisWaypoint.start = this.route.days[day].startTime;
					thisWaypoint.end = thisWaypoint.start;
				}

				// add to total if layover time exists
				if (thisWaypoint.layOver.seconds > 0) {
					this.route.days[day].totals.time += thisWaypoint.layOver.seconds;
					this.route.totals.time += thisWaypoint.layOver.seconds;

					// add layover time + travel time to the stop to get the approx end time.
					thisWaypoint.end = dateFuncs.addTime(startDateTime, thisWaypoint.layOver.seconds + thisWaypoint.time);

					if (thisWaypoint.end == null) {
						alert('Route time has gone past midnight and should make a new day');
						this.route.days[day].locked = true;
					} else {
						this.route.days[day].locked = false;
					}
				}

				// add poly lines for journey
				this.drawLines();
			});
		},


		async removeWaypoint(index) {
			if (await this.$refs.confirm.open('Delete', 'Are you sure you want to delete this waypoint?')) {
				let day = this.selectedDay;
				//var waypoint = this.route.waypoints[index];
				this.route.days[day].waypoints.splice(index, 1);
				this.recalcWaypoints();
			}
		},

		initMap() {
			// set map centre and zoom
			this.map = L.map('map').setView([53.019808, -1.642562], 6);

			// set map background tiles
			this.tileLayer = L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
				maxZoom: 18,
				attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
			});

			// add the tile layer to the map
			this.tileLayer.addTo(this.map);

			// add search
			var vm = this;

			var geoMarker = new L.ExtraMarkers.icon({
				markerColor: 'orange',
				shape: 'penta'
			});

			this.searchMarker = L.Control.geocoder({
				defaultMarkGeocode: false,
				expand: 'click',
				showResultIcons: true,

				geocoder: new L.Control.Geocoder.Nominatim({
					geocodingQueryParams: {
						countrycodes: 'gb'
					},

					htmlTemplate: function (r) {
						var a = r.address,
							parts = [];
						if (a.building || a.amenity || a.shop || a.tourism) {
							parts.push('{amenity} {shop} {building} {tourism} {house_name}');
						}

						if (a.city || a.town || a.village || a.suburb || a.locality || a.hamlet || a.road) {
							parts.push('<span class="' + (parts.length > 0 ? 'leaflet-control-geocoder-address-detail' : '') + '">{house_number} {road}, {hamlet} {locality} {village} {town} {city}</span>');
						}

						if (a.county || a.postcode) {
							parts.push('<span class="' + (parts.length > 0 ? 'leaflet-control-geocoder-address-context' : '') + '">{county} {postcode}</span>');
						}

						return vm.template(parts.join('<br/>'), a, true);
					}
				})
			})
				.on('markgeocode', function (e) {
					let gAddress = e.geocode.properties.address;

					let gName = e.geocode.name.substr(0, e.geocode.name.indexOf(','));

					let markerId = e.geocode.properties.place_id;

					let marker = L.marker(e.geocode.center, {
						icon: geoMarker
					}).bindPopup(e.geocode.html);

					marker.on('mouseover', function (e) {
						this.openPopup();
						vm.wayPointMouseOver(markerId, true);
					});

					marker.on('mouseout', function (e) {
						this.closePopup();
						vm.wayPointMouseOut(markerId, true);
					});

					marker.on('click', function () {
						// do we have a stop with this place ID already?
						let canSave = false;

						let stop = vm.stops.find((stop) => stop.MapId === markerId);

						let layer = vm.layers.find((layer) => layer.id === 1);

						// yes, just add the waypoint and carry on.
						if (typeof stop !== 'undefined') {
							// get stop over layer

							marker = layer.features._layers[markerId];

							vm.layerChanged(1, true);
						} else {
							// get address in a format we require for a waypoint
							var address = {
								Latitude: e.geocode.center.lat,
								Longitude: e.geocode.center.lng,
								Address1: (gAddress.house_number || gAddress.building || '') + ' ' + gAddress.road,
								Address2: gAddress.hamlet || gAddress.suburb,
								Town: gAddress.city || gAddress.town || gAddress.village,
								Postcode: gAddress.postcode
							};

							marker._leaflet_id = markerId;

							marker.addTo(layer.features);

							vm.layerChanged(1, true);

							canSave = true;
						}

						marker._properties = {
							id: 0,
							type: waypointType.stop,
							name: gName,
							title: '',
							address: address,
							date: '',
							confirmed: null
						};

						vm.addWaypoint(marker._leaflet_id, marker._properties, canSave);
					});

					marker.addTo(vm.map).openPopup();

					vm.map.fitBounds(e.geocode.bbox);

					vm.map.setZoom(16);



				})
				.addTo(vm.map);
		},

		initLayer(layerId, cluster) {
			var vm = this;

			let markersArr = [];

			let layer = this.layers.find((layer) => layer.id === layerId);

			var clusterConfig = {
				disableClusteringAtZoom: 9,
				maxClusterRadius: 50,
				removeOutsideVisibleBounds: true,
				spiderfyOnMaxZoom: false
			};

			switch (layerId) {
				case 0: // clock
					this.clocks.forEach((clock) => {
						if (clock.Address && !clock.Address.Empty) {
							var clockMarker = new L.ExtraMarkers.icon({
								markerColor: 'blue',
								shape: 'circle'
							});

							var marker = L.marker([clock.Address.Latitude, clock.Address.Longitude], {
								icon: clockMarker
							});
							// use our own marker id so it never freakin' changes man.
							marker._leaflet_id = clock.NanId;

							var popUpHtml =
								'<b-card><h4>' +
								clock.Name +
								'</h4>' +
								this.withBr(clock.Address.Address1) +
								this.withBr(clock.Address.Address2) +
								this.withBr(clock.Address.Town) +
								this.withBr(clock.Address.County) +
								this.withBr(clock.Address.Postcode) +
								this.withBr(clock.Address.What3Words) +
								'</b-card>';

							marker._properties = {
								id: clock.Id,
								type: waypointType.clock,
								name: clock.Name,
								title: '',
								address: clock.Address,
								date: '',
								confirmed: null
							};

							marker.bindPopup(popUpHtml).on('click', function (e) {
								vm.addWaypoint(this._leaflet_id, marker._properties, false);
							});

							marker.on('mouseover', function (e) {
								this.openPopup();
								vm.wayPointMouseOver(this._leaflet_id, true);
							});
							marker.on('mouseout', function (e) {
								this.closePopup();
								vm.wayPointMouseOut(this._leaflet_id, true);
							});

							markersArr.push(marker);
						}
					});

					break;

				case 1: // stop
					this.stops.forEach((stop) => {
						if (stop.Address && !stop.Address.Empty) {
							var stopMarker = new L.ExtraMarkers.icon({
								markerColor: 'orange',
								shape: 'penta'
							});

							var marker = L.marker([stop.Address.Latitude, stop.Address.Longitude], {
								icon: stopMarker
							});
							// use our own marker id so it never freakin' changes man.

							marker._leaflet_id = stop.MapId;

							var popUpHtml = '<b-card><h4>' + stop.Name + '</h4>' + this.withBr(stop.Address.Address1) + this.withBr(stop.Address.Address2) + this.withBr(stop.Address.Town) + this.withBr(stop.Address.County) + this.withBr(stop.Address.Postcode) + '</b-card>';

							marker._properties = {
								id: stop.Id,
								type: waypointType.stop,
								name: stop.Name,
								title: '',
								address: stop.Address,
								date: '',
								confirmed: null
							};

							marker.bindPopup(popUpHtml).on('click', function (e) {
								vm.addWaypoint(this._leaflet_id, marker._properties, false);
							});

							marker.on('mouseover', function (e) {
								this.openPopup();
								vm.wayPointMouseOver(this._leaflet_id, true);
							});
							marker.on('mouseout', function (e) {
								this.closePopup();
								vm.wayPointMouseOut(this._leaflet_id, true);
							});

							markersArr.push(marker);
						}
					});
					break;

				case 2: // engineer
					this.engineers.forEach((engineer) => {
						if (engineer.Address && !engineer.Address.Empty) {
							var engineerMarker = new L.ExtraMarkers.icon({
								markerColor: 'green-light',
								shape: 'circle'
							});

							var marker = L.marker([engineer.Address.Latitude, engineer.Address.Longitude], {
								icon: engineerMarker
							});

							// use our own marker id so it never freakin' changes man.
							marker._leaflet_id = engineer.Id;

							marker._properties = {
								id: 0,
								type: waypointType.technician,
								name: engineer.FullName,
								title: '',
								address: engineer.Address,
								date: '',
								confirmed: null
							};

							marker.bindPopup(engineer.FullName).on('click', function (e) {
								vm.addWaypoint(this._leaflet_id, marker._properties, false);
							});

							marker.on('mouseover', function (e) {
								this.openPopup();
								vm.wayPointMouseOver(this._leaflet_id, true);
							});
							marker.on('mouseout', function (e) {
								this.closePopup();
								vm.wayPointMouseOut(this._leaflet_id, true);
							});

							markersArr.push(marker);
						}
					});

					break;

				case 3: // check in task
					this.jobs.forEach((job) => {
						if (job.Address && !job.Address.Empty) {
							/*
							...colours based on their date
							- green: 4 weeks before date
							- orange: 0-4 weeks after date
							- red:  over >4 weeks after date
							
							
							... shapes based on type
							star
							circle 
							square
							penta
							*/

							var diff = dateFuncs.getDifference(job.Scheduled);

							let colour = 'blue';

							let typeString = null;
							let typeIcon = null;


							switch (true) {
								case diff > 0 && diff <= 4:
									colour = 'green';
									break;

								case diff < 0 && diff >= -4:
									colour = 'orange';
									break;

								case diff < -4:
									colour = 'red';
									break;
							}


							switch (job.JobType) {
								case 0:

									typeString = '(enquiry)';
									typeIcon = '❔';
									break;

								case 1:

									typeString = '(problem)';
									typeIcon = '⚠';
									break;

								case 2:

									typeString = '(service)';
									typeIcon = '🛠';
									break;

								case 3:

									typeString = '(job)';
									typeIcon = '⏲';
									break;
							}

							if (job.Confirmed) {

								typeIcon = '✔';

							}




							var clockMarker = new L.ExtraMarkers.icon({
								icon: 'fa-number',
								markerColor: colour,
								shape: 'square',
								number: typeIcon,


							});

							var marker = L.marker([job.Address.Latitude, job.Address.Longitude], {
								icon: clockMarker
							});
							// use our own marker id so it never freakin' changes man.
							marker._leaflet_id = job.NanId;

							let confirmed = (job.Confirmed ? ' (confirmed)' : '');
							var popUpHtml =
								'<b-card><h4>' +
								job.Name + ' ' + typeString +
								'</h4>' +
								'<h5>' +
								job.Title + confirmed +
								'</h5>' +
								'<p>' +
								dateFuncs.humanDateFormat(job.Scheduled) +
								'</p>' +
								this.withBr(job.Address.Address1) +
								this.withBr(job.Address.Address2) +
								this.withBr(job.Address.Town) +
								this.withBr(job.Address.County) +
								this.withBr(job.Address.Postcode) +
								this.withBr(job.Address.What3Words) +
								'</b-card>';

							marker._properties = {
								id: job.Id,
								type: waypointType.job,
								name: job.Name,
								title: '<a href="/jobs/' + job.JobId + '">' + job.Title + '</a>',
								address: job.Address,
								date: dateFuncs.humanDateFormat(job.Scheduled),
								confirmed: job.Confirmed
							};

							// click on the pop up info opens the add waypoint dialog.
							marker.bindPopup(popUpHtml).on('click', function (e) {
								vm.addWaypoint(this._leaflet_id, marker._properties, false);
							});

							// hover open the name of the marker
							marker.on('mouseover', function (e) {
								this.openPopup();
								vm.wayPointMouseOver(this._leaflet_id, true);
							});
							marker.on('mouseout', function (e) {
								this.closePopup();
								vm.wayPointMouseOut(this._leaflet_id, true);
							});

							markersArr.push(marker);
						}
					});

					break;

				default:
			}

			let markers;

			if (cluster) {
				markers = L.markerClusterGroup({
					clusterConfig
				});

				// store locally to hide/show
				layer.features = markers.addLayers(markersArr);
			} else {
				markers = L.layerGroup(markersArr);
				// store locally to hide/show
				layer.features = markers;
			}

			if (layer.active) this.map.addLayer(markers);
		},

		layerChanged(layerId, active) {
			let layer = this.layers.find((layer) => layer.id === layerId);

			if (active) {
				if (!this.map.hasLayer(layer.features)) {
					this.map.addLayer(layer.features);
				}
			} else {
				if (this.map.hasLayer(layer.features)) {
					this.map.removeLayer(layer.features);
				}
			}
		},

		// helper functions
		handleError(err) {
			let modal_options = {
				text: 'light',
				background: 'danger'
			};

			let message;

			if (err.response.data != '') {
				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;
			} else {
				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			message += '</br> Return to route plans list?';

			this.$refs.confirm.open('Error', message, false, modal_options).then((confirm) => {
				if (confirm) {
					this.$router.push({
						name: 'routeplans'
					});
				}
			});
		},

		niceTime(time) {
			return dateFuncs.getTime(time);
		},

		getMiles(i) {
			return (i * 0.000621371192).toFixed(2) + ' mi';
		},

		getHoursMins(d) {
			d = Number(d);
			var h = Math.floor(d / 3600);
			var m = Math.floor((d % 3600) / 60);
			var hDisplay = h > 0 ? h + (h == 1 ? ' hour, ' : ' hours, ') : ' 0 hours ';
			var mDisplay = m > 0 ? m + (m == 1 ? ' min' : ' mins') : ' 0 mins';
			return hDisplay + mDisplay;
		},

		template(str, data) {
			return str.replace(/\{ *([\w_]+) *\}/g, function (str, key) {
				var value = data[key];
				if (value === undefined) {
					value = '';
				} else if (typeof value === 'function') {
					value = value(data);
				}
				return value;
			});
		},

		withBr(str) {
			return !str || 0 === str.length ? '' : str + '</br>';
		}
	},

	watch: {
		selectedDay: function (_day) {
			this.$nextTick(() => {
				// do we have a previous day?
				// recalc if we have asked this day to, based on changes to previous day
				if (this.route.days[_day].recalc == true) {
					this.recalcWaypoints();
					this.route.days[_day].recalc = false;
				}

				this.drawLines();
			});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/routeplan/routeplan-inner.vue